import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import AppProviders from './components/AppProviders' // move to context
import App from './App'
import reportWebVitals from './reportWebVitals'
import * as Sentry from '@sentry/react'
import './i18n'
import { BrowserRouter } from 'react-router-dom'
Sentry.init({
    dsn: 'https://674460d792484f8ab54692f4df9cfaa3@o4504117825896449.ingest.sentry.io/4504117828452352',
    // integrations: [new BrowserTracing()],

    // We recommend adjusting this value in production, or using tracesSampler
    // for finer control
    tracesSampleRate: 1.0,
    integrations: [new Sentry.Replay()],
})
ReactDOM.render(
    <AppProviders>
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </AppProviders>,
    document.getElementById('root')
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
